import React from 'react'
import { useMessagewarnlistModel } from '../messagewarnlistModel'
import { ISearchValue, SearchTypeEnum } from '@/components/YhPageHeader/Types'
import { YhPageHeader } from '@/components/YhPageHeader'
import { useDictModel } from '@/views/base/dict/dictModel'
import { messageStatusDs } from '@/types/FranchiseeDs'

export function PageHeader() {
    const { searchParam, updateSearchParam, resetSearchParam, loadData } = useMessagewarnlistModel()
    const searchFields = [
        {
            type: SearchTypeEnum.Select,
            placeholder: '状态',
            fieldName: 'status',
            span: 3,
            options: messageStatusDs,
        }
    ]

    const searchMoreFields = []

    return (
        <YhPageHeader
            title=""
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            searchMoreFields={searchMoreFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    )
}
